import { Star, ExternalLink } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function GoogleReviews() {
  return (
    <div
      data-testid="google-reviews-widget"
      className="card-brutal flex flex-col items-center gap-4 p-6 md:flex-row md:gap-8 md:p-8"
    >
      <div className="flex flex-col items-center md:items-start">
        <div className="flex items-center gap-2">
          <span className="text-xs font-bold uppercase tracking-widest text-black/60">Rated on</span>
          <span className="display text-base font-black">Google</span>
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <div className="display text-5xl font-black md:text-6xl" data-testid="google-rating-value">
            {COMPANY.rating}
          </div>
          <div className="display text-2xl font-bold text-black/40">/5</div>
        </div>
        <div className="mt-1 flex items-center gap-1 text-[#FFD700]">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={18} fill="#FFD700" strokeWidth={0} />
          ))}
        </div>
        <div className="mt-1 text-xs font-medium text-black/60">
          Based on {COMPANY.reviewsCount}+ verified reviews
        </div>
      </div>

      <div className="hidden h-20 w-px bg-black/10 md:block" />

      <div className="flex flex-1 flex-col items-center gap-3 md:items-start">
        <p className="text-sm leading-relaxed text-black/70 md:text-base">
          "Real growth, real reporting, real partnership. Orina is the team you call when you actually want to scale on marketplaces."
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            data-testid="google-read-reviews"
            href="https://google.com/maps"
            target="_blank"
            rel="noreferrer"
            className="btn-brutal secondary"
          >
            Read Reviews <ExternalLink size={14} />
          </a>
          <a
            data-testid="google-leave-review"
            href="https://google.com/maps"
            target="_blank"
            rel="noreferrer"
            className="btn-brutal"
          >
            Leave a Review
          </a>
        </div>
      </div>
    </div>
  );
}
